import { onEcwid } from './event.js'
import { GenericObjectAny } from '../utilities/generic.js'

type State = {
	custom: {
		loggedIn: boolean
	},
	customer?: GenericObjectAny,
}

const state: State = {
	custom: {
		loggedIn: false
	},
	customer: undefined,
}
export const getState = (
): State => {
	return state
}

const listeners: ((state: GenericObjectAny) => void)[] = []

export const addListener = (
	callback: () => void,
): void => {
	listeners.push(callback)
}

export const removeListener = (
	callback
): void => {
	const index = listeners.indexOf(callback)
	if (index >= 0) {
		listeners.splice(index, 1)
	}
}

const dispatch = (
): void => {
	for (const listener of listeners) {
		listener(state)
	}
}

onEcwid(() => {
	// Populate ecwid state.
	if (!state.custom.loggedIn) {
		state.custom.loggedIn = document.body.classList.contains('ecwid-customer-loggedIn')
	}

	if (window.Ecwid.OnSetProfile) {
		window.Ecwid.OnSetProfile.add((
			customer
		) => {
			state.custom.loggedIn = !!customer
			state.customer = customer
			dispatch()
		})
	}
	dispatch()
})